import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import configureStore from './store/configureStore'
import App from './App'
import * as serviceWorker from './serviceWorker'

import { ThemeProvider } from '@material-ui/styles'
import 'typeface-roboto'
import theme from './theme'
import { msalConfig } from './auth/authConfig'

// Get the application-wide store instance, prepopulating with state from the server where available.
// eslint-disable-next-line dot-notation
const initialState = window['initialReduxState']
const store = configureStore(initialState)
const rootElement = document.getElementById('root')
const msalInstance = new PublicClientApplication(msalConfig)

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </ThemeProvider>
    </BrowserRouter>
  </Provider>,
  rootElement
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

serviceWorker.unregister()
